import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAngel = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "19px",
	fill: "white",
	height: "13px",
	viewBox: "0 0 19 13",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	id: "angel",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "angel" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("defs", {}),
		/* @__PURE__ */ _jsx("g", {
			id: "Symbols",
			stroke: "none",
			strokeWidth: 1,
			fill: "white",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
				fill: "white",
				d: "M16.5582,10.0205 C19.1422,8.1795 18.6472,6.2425 18.6472,6.2425 C18.6472,6.2425 18.1292,6.9065 17.3162,7.4375 C18.1552,4.1945 16.3192,0.6335 16.3192,0.6335 C16.3192,0.6335 16.0572,4.7845 13.5672,5.8025 C11.0782,6.8205 11.1902,8.1905 11.1902,8.1905 C11.1902,8.1905 12.7892,8.0925 13.1062,9.4805 C13.4222,10.8695 12.7492,11.3345 12.7492,11.3345 C12.9932,10.9925 13.1092,10.5575 13.0402,10.1095 C12.8982,9.1985 12.0442,8.5745 11.1332,8.7155 C10.2222,8.8575 9.6002,9.7115 9.7402,10.6225 C10.0322,12.5185 12.2182,13.1745 15.2372,12.1565 C18.2432,11.1425 18.5512,9.3895 18.5512,9.3895 C18.5512,9.3895 17.6042,9.9565 16.4522,10.0935 C16.4872,10.0695 16.5222,10.0455 16.5582,10.0205",
				id: "Fill-147"
			}), /* @__PURE__ */ _jsx("path", {
				fill: "white",
				d: "M7.7413,8.7158 C6.8303,8.5738 5.9763,9.1978 5.8353,10.1088 C5.7653,10.5578 5.8813,10.9918 6.1263,11.3348 L6.1253,11.3348 C6.1253,11.3348 5.4523,10.8688 5.7683,9.4808 C6.0853,8.0918 7.6843,8.1898 7.6843,8.1898 C7.6843,8.1898 7.7963,6.8208 5.3073,5.8028 C2.8173,4.7848 2.5553,0.6328 2.5553,0.6328 C2.5553,0.6328 0.7193,4.1948 1.5583,7.4368 C0.7453,6.9068 0.2273,6.2428 0.2273,6.2428 C0.2273,6.2428 -0.2677,8.1798 2.3163,10.0208 C2.3523,10.0458 2.3873,10.0688 2.4223,10.0938 C1.2703,9.9568 0.3233,9.3898 0.3233,9.3898 C0.3233,9.3898 0.6313,11.1428 3.6373,12.1568 C6.6563,13.1748 8.8423,12.5188 9.1343,10.6228 C9.2743,9.7108 8.6523,8.8578 7.7413,8.7158",
				id: "Fill-149"
			})] }) })
		})
	]
});
export default SvgAngel;
